var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSockets(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 22,
    viewBox: "0 0 28 22",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(.048 .5)",
    fill: "#2396FD",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17.1,
    y: 16.435,
    width: 9.9,
    height: 4.565,
    rx: 0.972
  }), /*#__PURE__*/React.createElement("rect", {
    y: 16.435,
    width: 9.9,
    height: 4.565,
    rx: 0.972
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.772 0h2.556c.537 0 .972.435.972.972v8.1a.972.972 0 0 1-.972.971h-2.556a.972.972 0 0 1-.972-.972V.972c0-.537.435-.972.972-.972z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSockets);
export default __webpack_public_path__ + "static/media/sockets.2a42387ad0681e71907d2cef2232d7dc.svg";
export { ForwardRef as ReactComponent };